import type { BillingPlan, LicenseMode } from '../types'
import { LicensePack } from './license-pack.tsx'

interface Props {
  mode: LicenseMode
  data: BillingPlan[]
  showDiscount?: boolean
}

export const LicenseOverview = ({ data, mode, showDiscount }: Props) => {
  return (
    <div className="grid h-full gap-8 pt-4 xl:grid-flow-col xl:grid-cols-3">
      {data.map((license, index) => {
        return (
          <LicensePack
            key={license.name}
            licenses={data}
            license={license}
            mode={mode}
            isRecommend={index == 2}
            showDiscount={showDiscount}
          />
        )
      })}
    </div>
  )
}
